export default "__VITE_ASSET__C46YIlkj__"